import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import AcessoNegado from '../components/AcessoNegado';

const ProtectedRoute = ({ children, permissionPath = "" }) => {
  const token = localStorage.getItem('token'); // trocar para "null" se precisar derrubar os usuários
  const permissoes = JSON.parse(localStorage.getItem('permissoes'));

  if (token === null) {
    localStorage.removeItem("token");
    localStorage.removeItem("permissoes");
    localStorage.removeItem("usuario");
    localStorage.removeItem("usuarioId");
  }

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (token) {
        try {
          const decodedToken = jwtDecode(token);
          const currentTime = Date.now() / 1000; // Tempo atual em segundos

          if (decodedToken.exp < currentTime) {
            console.log("Token expirado");
            localStorage.removeItem('token'); // Remover o token
            window.location.href = '/login'; // Redirecionar para a página de login
          }
        } catch (error) {
          console.error('Erro ao decodificar o token:', error);
          localStorage.removeItem('token');
          window.location.href = '/login';
        }
      }
    }, 1000); // Verifica a cada 1 segundo (1000 milissegundos)

    return () => clearInterval(intervalId); // Limpa o intervalo quando o componente for desmontado
  }, [token]);

  // Se não houver token, redireciona para a página de login imediatamente
  if (!token) {
    return <Navigate to="/login" />;
  }

  // Função para acessar permissões aninhadas (como 'paginas.produtos')
  const getPermission = (obj, path) => {
    return path.split('.').reduce((acc, key) => acc && acc[key], obj);
  };

  // Se permissionPath não for fornecido, assume que o acesso é permitido
  const hasPermission = permissionPath ? getPermission(permissoes, permissionPath) : true;

  // Se o usuário não tiver a permissão necessária, redireciona para uma página de acesso negado
  if (!hasPermission) {
    return <AcessoNegado />;
  }

  // Se o token existir e ainda não estiver expirado, renderiza a página protegida
  return children;
};

export default ProtectedRoute;